import React, { Component } from 'react';
import Dropzone from 'react-dropzone'

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import fetchDux from '../../../state/fetch-dux';

import UploadFileForm from './forms/UploadFileForm';

class UploadFile extends Component {
  constructor(props) {
    super(props);
    this.state = { files: [] };
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleSubmit(data) {
    this.props.uploadFile(data);
  }
  render() {
    return (
      <div>
        <h1>File Upload</h1>
        <UploadFileForm onSubmit={this.handleSubmit}/>
      </div>
    )
  }
}

const mapState = state => {

  return {};
};
const mapDispatch = dispatch => bindActionCreators({
  uploadFile: fetchDux.uploadFile.createAction,
  clearUploadFile: fetchDux.uploadFile.clearAction,
}, dispatch);

export default connect(mapState, mapDispatch)(UploadFile);


// WEBPACK FOOTER //
// ./src/components/routes/files/UploadFile.js